<template>
  <v-app style="background-color: #ffffff">
    <v-snackbar
      style="margin-top: 11px"
      :color="
        $store.state.snackBar.color == undefined
          ? 'success'
          : $store.state.snackBar.color
      "
      v-model="$store.state.snackBar.active"
      :timeout="
        $store.state.snackBar.timeout == undefined
          ? 3000
          : $store.state.snackBar.timeout
      "
      top
      app
      centered
    >
      <div style="width: 100%; text-align: center">
        <span style="font-family: Iransans">{{
          $store.state.snackBar.body
        }}</span>
      </div>
    </v-snackbar>
    <LoadingDialog
      :visible="$store.state.loadingDialog"
      v-model="$store.state.loadingDialog"
    />
    <AppBar v-if="$route.name != 'Login'" />
    <Drawer v-if="$route.name != 'Login'" />
    <v-main >
      <!-- <v-card
        v-if="$route.name != 'Login'"
        height="95%"
        style="
          border: 1px solid #ffd1b3;
          border-radius: 10px;
          margin: 1%;
          background-color: #e8e9eb;
        "
      > -->
        <!-- <v-card-title style="background-color: #f5c07f; color: white"
          ><span class="dashboardcardtitle">{{
            $route.meta.title
          }}</span></v-card-title> -->
        <!-- <v-divider class="mx-4"></v-divider> -->
        <!-- <v-card-text> -->
          <router-view />
        <!-- </v-card-text> -->
      <!-- </v-card> -->
      <!-- <div v-else>
        <router-view />
      </div> -->
    </v-main>
  </v-app>
</template>
<script>
import Drawer from "./components/Drawer";
import AppBar from "./components/AppBar";
import LoadingDialog from "./components/dialogs/LoadingDialog.vue";
import "./style.scss";
export default {
  name: "App",
  data: () => ({
    requestParams: {
      controller: "",
      data: {},
      commitFunction: "",
      callBack: (entrance) => {},
    },
  }),
  mounted() {
    // this.requestParams.controller = "Account/isAuthenticated";
    // this.requestParams.commitFunction = "SET_ISAUTHENTICATED";
    // this.requestParams.callBack = (entrance) => {
    //   this.callBackIsAuthenticated(entrance);
    // };
    // this.$store.dispatch("getRequest", { self: this });
    var userInfo = localStorage.getItem("userInfo");
    console.log(userInfo);
    if (
      this.$route.name != "Login" &&
      !this.$store.state.userInfo.isAuthenticated
    ) {
      this.$store.commit("SET_SNACKBAR", {
        active: true,
        body: "مجوز شما باطل شده است، لطفا دوباره وارد شوید.",
        color: "red",
      });
      this.$store.commit("SET_ISAUTHENTICATED", false);
      this.$router.replace({ name: "Login" });
    }
  },
  components: {
    Drawer,
    AppBar,
    LoadingDialog,
  },
  methods: {
    callBackIsAuthenticated() {
      if (
        this.$route.name != "Login" &&
        !this.$store.state.userInfo.isAuthenticated
      ) {
        this.$store.commit("SET_SNACKBAR", {
          active: true,
          body: "مجوز شما باطل شده است، لطفا دوباره وارد شوید.",
          color: "red",
        });
        this.$store.commit("SET_ISAUTHENTICATED", false);
        this.$router.replace({ name: "Login" });
      }
    },
  },
};
</script>
